import { render, staticRenderFns } from "./addCampain.vue?vue&type=template&id=40eca712"
import script from "./addCampain.vue?vue&type=script&lang=js"
export * from "./addCampain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports